import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ApiErrorState } from '../components/ApiErrorState.tsx';
import { Cargando } from '../components/FullScreenMessage.tsx';
import { useMyLeagues } from '../features/leagues/hooks.ts';

export function LeaguesPage() {
  const { t } = useTranslation();
  const { data: leagues, isPending, error } = useMyLeagues();

  return (
    <>
      <div className="mb-4 flex items-center justify-between gap-4">
        <h1 className="text-xl font-bold">{t('leagues.list.title')}</h1>
      </div>

      <div className="mb-4 flex flex-col gap-2 sm:flex-row">
        <Link to="/leagues/new" className="btn-primario no-underline" data-test="ir-crear-liga">
          {t('leagues.list.create')}
        </Link>
        <Link
          to="/leagues/join"
          className="btn-secundario w-full no-underline sm:w-auto"
          data-test="ir-unirse-liga"
        >
          {t('leagues.list.join')}
        </Link>
      </div>

      {error ? <ApiErrorState error={error} /> : null}
      {isPending ? <Cargando text={t('common.loading')} /> : null}

      {leagues && leagues.length === 0 ? (
        <section className="tarjeta text-center" data-test="ligas-vacio">
          <p className="mb-1">{t('leagues.list.empty')}</p>
          <p className="text-sm text-tenue">{t('leagues.list.emptyHint')}</p>
        </section>
      ) : null}

      <ul className="list-none space-y-3 p-0" data-test="lista-ligas">
        {leagues?.map((league) => (
          <li key={league.id}>
            <Link
              to={`/leagues/${league.id}`}
              className="tarjeta block no-underline"
              data-test="liga"
              data-league-name={league.name}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="truncate font-bold text-texto">{league.name}</p>
                  <p className="text-sm text-tenue">
                    {league.competition_name} · {league.season_label}
                  </p>
                </div>
                {league.role === 'owner' ? (
                  <span className="shrink-0 rounded-full border border-acento px-2 py-0.5 text-xs font-semibold text-acento">
                    {t('leagues.list.youAreAdmin')}
                  </span>
                ) : null}
              </div>
              <p className="mt-2 text-sm text-tenue">
                {t('leagues.list.members', { count: league.member_count })}
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
}
